<template>
  <div class="product-lift py-3 col-lg-4 col-md-6 col-12">
    <a class="product-image-wrapper" :href="product.link"
      ><picture>
        <source ref="webpEl" :srcset="`${getImage}.webp`" type="image/webp" />
        <source ref="jpgEl" :srcset="`${getImage}`" type="image/jpeg" />
        <img :src="getImage" ref="imgEl" alt="" loading="lazy" /> </picture
    ></a>
    <a :href="product.link">
      <p class="title">{{ product.title.rendered }}</p>
    </a>
    <p class="description" v-html="filteredContent"></p>
    <a :href="product.link">
      Tuotetiedot <i class="fal fa-long-arrow-right"></i>
    </a>
  </div>
</template>

<script>
import { imageSourceFromProduct } from "../../shared/helpers";

export default {
  name: "ProductLift",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$refs.imgEl.addEventListener(
      "error",
      () => {
        this.$refs.webpEl.srcset = this.$refs.jpgEl.srcset;
      },
      { once: true }
    );
  },
  computed: {
    getImage() {
      return imageSourceFromProduct(this.product);
    },
    filteredContent() {
      let contentHolder;
      if (this.product.acf.kuvaus?.length > 0)
        contentHolder = this.product.acf.kuvaus;
      else {
        const { content } = this.product;
        const { rendered } = content;
        contentHolder = rendered;
      }
      const split = contentHolder.split("\n");
      for (const s of split) {
        if (s.length > 0) {
          return s;
        }
      }
      return contentHolder;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-lift {
  img {
    height: 300px;
    @media screen and (max-width: 554px) {
      height: 220px;
    }
    width: 100%;
    object-fit: cover;
  }
  .title {
    font-weight: bold;
    font-size: 1.25rem;
    margin: 16px 0;
    color: var(--bs-dark);
  }
  .description {
    &:deep(p),
    &:deep(strong) {
      font-size: 1rem;
      font-weight: 400;
    }
  }
  a {
    color: var(--bs-orange);
    text-decoration: none;
  }
}
</style>
